/* Papeterie Montparnasse - recherche-plume header (DEV, reversible).
   Champ central + auto-completion (suggest.json, repli plein-texte) + correction
   de fautes maison + navigation clavier. Formulaire standard intact (Entree -> /search).
   Reversible : retirer le <script>/<link pm-header.css> dans theme.liquid + les assets. */
(function () {
  var PLACEHOLDER = 'Rechercher un agenda, un carnet, des crayons, une encre, du papier à lettres, un stylo…';
  var MIN = 2;
  var searchUrl = '/search';

  function fmtPrice(v) {
    if (v == null || v === '') return '';
    v = String(v);
    if (/[€$£]/.test(v)) return v;
    var n = parseFloat(v.replace(',', '.'));
    if (isNaN(n)) return v;
    try { return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Correction de fautes maison : quand Shopify ne renvoie rien, proposer
     « Vouliez-vous dire <Marque> ? » (Levenshtein sur les marques du catalogue). */
  var PM_BRANDS = [
    'Waterman', 'Parker', 'Lamy', 'Pilot', 'Kaweco', 'Sailor', 'Cross', 'Sheaffer',
    'Diplomat', 'Platinum', 'Fisher Space Pen', "Caran d'Ache", 'Faber-Castell',
    'Ferris Wheel Press', 'Jacques Herbin', 'Pentel', 'Uni-Ball', 'Stabilo', 'Staedtler',
    'Maped', 'Papermate', 'Clairefontaine', 'Rhodia', 'Leuchtturm1917', 'Midori',
    'Filofax', 'Quo Vadis', 'Semikolon', 'Paperblanks', 'Castelli Milano', 'Legami Milano',
    'Papier Tigre', 'Apica', 'Kokuyo', 'Stalogy', 'Tomoe River', "Traveler's Company",
    'Lihit Lab', 'Oberthur', 'Exacompta', 'Gmund', 'Hahnemuhle', 'Agenda Moderne',
    'Original Crown Mill', 'G.Lalo', 'Editions des Correspondances', 'Eberhard Faber',
    'Lefranc Bourgeois', 'Bortoletti', 'Zequenz', 'Darwi', 'Mignon', 'Kiub'
  ];
  function pmNorm(s) {
    s = String(s == null ? '' : s).normalize('NFD');
    var out = '';
    for (var i = 0; i < s.length; i++) { var c = s.charCodeAt(i); if (c >= 0x300 && c <= 0x36f) continue; out += s[i]; }
    return out.toLowerCase().replace(/[^a-z0-9]/g, '');
  }
  var PM_BRANDS_KEY = PM_BRANDS.map(function (b) { return { label: b, key: pmNorm(b) }; });
  function pmLev(a, b) {
    var m = a.length, n = b.length, i, j;
    if (!m) return n; if (!n) return m;
    var prev = [], cur = [];
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
      }
      var t = prev; prev = cur; cur = t;
    }
    return prev[n];
  }
  function suggestBrand(q) {
    var nq = pmNorm(q);
    if (nq.length < 4) return null;
    var best = null, bestD = 99;
    for (var i = 0; i < PM_BRANDS_KEY.length; i++) {
      var b = PM_BRANDS_KEY[i];
      if (Math.abs(b.key.length - nq.length) > 2) continue;   // ecart de longueur trop grand -> ignore
      var d = pmLev(nq, b.key);
      if (d < bestD) { bestD = d; best = b; }
    }
    if (!best || bestD === 0) return null;                    // rien de proche, ou deja exact
    var maxD = nq.length <= 5 ? 1 : 2;                        // fautes legeres uniquement
    return bestD <= maxD ? best.label : null;
  }

  function buildSearch() {
    var wrapper = document.querySelector('.header__wrapper');
    if (!wrapper) return;
    if (wrapper.querySelector('.pm-header-search')) return; // deja injecte

    var trigger = wrapper.querySelector('a[aria-controls="search-drawer"]');
    if (trigger && trigger.getAttribute('href')) searchUrl = trigger.getAttribute('href');

    var container = document.createElement('div');
    container.className = 'pm-header-search';
    container.innerHTML =
      '<form action="' + searchUrl + '" method="get" role="search" class="pm-search-form">' +
        '<div class="pm-search-field">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
            '<circle cx="11" cy="11" r="7"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line>' +
          '</svg>' +
          '<input type="search" name="q" autocomplete="off" autocorrect="off" autocapitalize="off" ' +
            'spellcheck="false" aria-label="Rechercher" role="combobox" aria-autocomplete="list" ' +
            'aria-expanded="false" aria-controls="pm-predictive-list" placeholder="' + PLACEHOLDER + '">' +
        '</div>' +
        '<div class="pm-predictive" id="pm-predictive-list" role="listbox" aria-label="Suggestions de recherche" hidden></div>' +
        '<p class="sr-only" role="status" aria-live="polite" data-pm-status></p>' +
      '</form>';

    var logo = wrapper.querySelector('.header__logo');
    if (logo && logo.nextSibling) wrapper.insertBefore(container, logo.nextSibling);
    else wrapper.appendChild(container);

    wire(container);
  }

  function wire(container) {
    var input = container.querySelector('input[type="search"]');
    var panel = container.querySelector('.pm-predictive');
    var status = container.querySelector('[data-pm-status]');
    var timer = null, controller = null, lastQ = '', activeIndex = -1;

    function options() { return panel.querySelectorAll('a[role="option"]'); }
    function hide() {
      panel.hidden = true; panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    }
    // Affiche le panneau, rend les liens navigables (role=option) et annonce le total.
    function showPanel() {
      var links = panel.querySelectorAll('a');
      for (var i = 0; i < links.length; i++) { links[i].id = 'pm-opt-' + i; links[i].setAttribute('role', 'option'); }
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
      if (status) status.textContent = links.length ? (links.length + ' suggestion' + (links.length > 1 ? 's' : '') + ' disponibles') : 'Aucune suggestion';
    }
    function setActive(idx) {
      var opts = options();
      if (!opts.length) return;
      for (var i = 0; i < opts.length; i++) opts[i].classList.remove('pm-active');
      if (idx < 0) idx = opts.length - 1;
      if (idx >= opts.length) idx = 0;
      activeIndex = idx;
      var o = opts[idx];
      o.classList.add('pm-active');
      input.setAttribute('aria-activedescendant', o.id);
      if (o.scrollIntoView) o.scrollIntoView({ block: 'nearest' });
    }

    function query(q) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var sig = controller && controller.signal;
      var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: sig })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return; // reponse perimee
          var res = (data && data.resources && data.resources.results) || {};
          if ((res.products || []).length) { render(q, res, null); return; }
          fallback(q, res, sig);   // aucun produit -> repli plein-texte (tolerant aux fautes)
        })
        .catch(function () {});
    }

    function fallback(q, res, sig) {
      // Vue pm-json (theme DEV) ; on propage preview_theme_id en apercu.
      var preview = '';
      var m = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
      if (m) preview = '&preview_theme_id=' + m[1];
      var url = searchUrl + '?q=' + encodeURIComponent(q) + '&view=pm-json&type=product' + preview;
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: sig })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          if (input.value.trim() !== q) return;
          var data = {};
          try { data = JSON.parse(t); } catch (e) {}
          render(q, res, (data.products || []).slice(0, 6));
        })
        .catch(function () { if (input.value.trim() === q) render(q, res, []); });
    }

    function render(q, res, approx) {
      var fallbackMode = approx != null;            // approx = tableau (eventuellement vide) => mode secours
      var products = fallbackMode ? approx : (res.products || []);
      var collections = res.collections || [], queries = res.queries || [];
      if (!products.length && !collections.length && !queries.length) {
        var dym = suggestBrand(q);
        var emptyHtml = '';
        if (dym) {
          emptyHtml += '<div class="pm-pred__dym">Vouliez-vous dire <a href="' + esc(searchUrl) + '?q=' +
            encodeURIComponent(dym) + '">' + esc(dym) + '</a> ?</div>';
        }
        emptyHtml += '<div class="pm-pred__empty">Aucune suggestion pour « ' + esc(q) + ' »</div>';
        panel.innerHTML = emptyHtml;
        showPanel();
        return;
      }
      var html = '<div class="pm-pred__grid">';
      // Colonne produits
      html += '<div class="pm-pred__col pm-pred__col--main">';
      if (products.length) {
        html += '<div class="pm-pred__eyb">' + (fallbackMode ? 'Résultats approchants' : 'Produits') + '</div>';
        if (fallbackMode) {
          html += '<div class="pm-pred__hint">Aucune correspondance exacte — voici les produits les plus proches.</div>';
        }
        products.forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          if (img && img.indexOf('width=') === -1) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          html += '<a class="pm-pred__res" href="' + esc(p.url) + '">' +
            '<span class="pm-pred__th">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="pm-pred__m"><span class="pm-pred__nm">' + esc(p.title) + '</span>' +
            (p.price != null && p.price !== '' ? '<span class="pm-pred__pr">' + esc(fmtPrice(p.price)) + '</span>' : '') +
            '</span></a>';
        });
      }
      html += '<a class="pm-pred__all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '">' +
        'Voir tous les résultats' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg></a>';
      html += '</div>';
      // Colonne collections + suggestions
      if (collections.length || queries.length) {
        html += '<div class="pm-pred__col pm-pred__col--side">';
        if (collections.length) {
          html += '<div class="pm-pred__eyb">Collections</div>';
          collections.forEach(function (c) {
            html += '<a class="pm-pred__sug" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
          });
        }
        if (queries.length) {
          html += '<div class="pm-pred__eyb pm-pred__eyb--mt">Suggestions</div>';
          queries.forEach(function (s) {
            html += '<a class="pm-pred__sug" href="' + esc(s.url) + '">' + esc(s.text) + '</a>';
          });
        }
        html += '</div>';
      }
      html += '</div>';
      panel.innerHTML = html;
      showPanel();
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      if (q.length < MIN) { hide(); lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function () { query(q); }, 180);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN && panel.innerHTML) showPanel();
    });
    // Navigation clavier dans le panneau : fleches haut/bas + Entree pour suivre.
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1); }
      else if (e.key === 'Enter') {
        var opts = options();
        if (activeIndex >= 0 && opts[activeIndex]) { e.preventDefault(); window.location.href = opts[activeIndex].getAttribute('href'); }
        // sinon : soumission normale du formulaire -> page /search
      } else if (e.key === 'Escape') { hide(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) hide();
    });
  }

  /* Aligne la largeur de la barre centrale sur l'empan reel de la navigation
     (bord gauche ~ A d'AGENDAS, bord droit ~ S de NOTEBOOKS). Lit le conteneur
     de nav reel -> reste coherent selon le viewport. Desktop uniquement. */
  function syncNavWidth() {
    var wrap = document.querySelector('.header__wrapper');
    if (!wrap) return;
    var desktop = window.matchMedia && window.matchMedia('(min-width: 1150px)').matches;
    if (!desktop) { wrap.style.removeProperty('--pm-nav-w'); return; }
    // Les items reels sont les <li> de premier niveau ; leur <ul> parent est en
    // display:contents (rect nul), d'ou une mesure sur les <li> directement.
    var items = wrap.querySelectorAll('.header__main-nav .header__link-list > ul > li');
    if (!items.length) items = wrap.querySelectorAll('.header__main-nav .header__link-list li');
    if (!items.length) return;
    var minL = Infinity, maxR = -Infinity;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (r.width > 0) { if (r.left < minL) minL = r.left; if (r.right > maxR) maxR = r.right; }
    }
    if (maxR <= minL) return;
    var w = Math.round(maxR - minL);
    if (w > 60) wrap.style.setProperty('--pm-nav-w', w + 'px');
  }
  var _navT = null;
  function scheduleSync() { if (_navT) clearTimeout(_navT); _navT = setTimeout(syncNavWidth, 80); }

  function init() {
    buildSearch();
    syncNavWidth();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncNavWidth);
    setTimeout(syncNavWidth, 300);
    if ('ResizeObserver' in window) {
      var wrap = document.querySelector('.header__wrapper');
      if (wrap) { try { new ResizeObserver(scheduleSync).observe(wrap); } catch (e) {} }
    }
    window.addEventListener('resize', scheduleSync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
